import { createJSONRequest } from './create-request'

export const fetchNetworkContacts = () => createJSONRequest({
  method: 'GET',
  url: '/api/network-contacts',
})

export const addNetworkContact = (elasticId, { phone = null, notes = null } = {}) => createJSONRequest({
  method: 'POST',
  url: '/api/network-contacts',
  data: { elastic_id: elasticId, phone, notes },
})

export const updateNetworkContact = (elasticId, { phone, notes }) => createJSONRequest({
  method: 'PUT',
  url: `/api/network-contacts/${elasticId}`,
  data: { phone, notes },
})

export const deleteNetworkContact = (elasticId) => createJSONRequest({
  method: 'DELETE',
  url: `/api/network-contacts/${elasticId}`,
})
